<template>
  <div class="main-content">
    <!-- 搜索栏 -->
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="功能名称">
        <el-input v-model="dataForm.name" placeholder="请输入功能名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-select v-model="dataForm.category" placeholder="请选择分类" clearable>
          <el-option label="默认显示" value="default"></el-option>
          <el-option label="展开显示" value="expand"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="dataForm.isEnable" placeholder="请选择状态" clearable>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
        <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>
      </el-form-item>
    </el-form>
    
    <!-- 列表 -->
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle" 
        style="width: 100%;">
      <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="id" header-align="center" align="center" label="ID" width="60"></el-table-column>
      <el-table-column prop="name" header-align="center" align="center" label="功能名称" width="120"></el-table-column>
      <el-table-column prop="icon" header-align="center" align="center" label="图标" width="80">
        <template slot-scope="scope">
          <span style="font-size: 28px;">{{ scope.row.icon }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="linkUrl" header-align="center" align="center" label="跳转链接" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="linkType" header-align="center" align="center" label="链接类型" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.linkType === 'inner'" type="success">内部页面</el-tag>
          <el-tag v-else-if="scope.row.linkType === 'miniapp'" type="primary">跳转小程序</el-tag>
          <el-tag v-else-if="scope.row.linkType === 'channels'" type="danger">跳转视频号</el-tag>
          <el-tag v-else type="warning">外部链接</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="bgColor" header-align="center" align="center" label="背景预览" width="100">
        <template slot-scope="scope">
          <div :style="{background: scope.row.bgColor, width: '60px', height: '30px', margin: '0 auto', borderRadius: '4px'}"></div>
        </template>
      </el-table-column>
      <el-table-column prop="category" header-align="center" align="center" label="分类" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.category === 'default'" type="primary">默认显示</el-tag>
          <el-tag v-else type="info">展开显示</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isEnable" header-align="center" align="center" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isEnable === 1" type="success">启用</el-tag>
          <el-tag v-else type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" header-align="center" align="center" label="排序" width="80"></el-table-column>
      <el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
export default {
  data () {
    return {
      dataForm: {
        name: '',
        category: '',
        isEnable: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 50,  // 增加默认每页显示数量
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  mounted () {
    this.getDataList()
  },
  activated () {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: '/functionGrid/page',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'name': this.dataForm.name,
          'category': this.dataForm.category,
          'isEnable': this.dataForm.isEnable
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.total  // 修复：使用 total 而不是 totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch(() => {
        this.dataList = []
        this.totalPage = 0
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/functionGrid/delete',
          method: 'post',
          data: ids
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    }
  }
}
</script>

